export const INSTITUTIONAL_MANAGEMENT_PAGES_ORDER_FOR_PERMISSIONS: string[] = [
  'bond_option',
  'public_agent',
  'citizen',
  'module',
  // 'organizational_unit',
  'public_agent_module_permission',
  'group_module_permission',
  'bond',
  'group',
  'benefit',
  'jobsite',
  'cost_center',
  'contract_type',
  'salary',
  'organizational_unit',
]
